import React, { useEffect, useState } from "react";
import Breadcrumb from "../../parts/Breadcrumb";
import { Link, useHistory } from "react-router-dom";
import ListSection from "../../components/ListSection";
import DeleteModel from "../../components/DeleteModel";
import labels from "../../constants/PushTemplate";
import configuration from "../../config";
import { toast } from "react-toastify";
import { pluck } from "underscore";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// List all push templates
function View(location) {
  const [accessRights, setAccessRights] = useState();
  const [isLoader, setIsLoader] = useState(false);

  const columns = [
    {
      title: "ID",
      field: "id",
      render: (rowData) =>
        accessRights?.edit ? (
          <Link
            className="text-indigo-600 hover:text-indigo-900"
            to={`/push-template/edit/${rowData.push_template_id}`}
          >
            {rowData.push_template_id}
          </Link>
        ) : (
          rowData.push_template_id
        ),
    },
    { title: "Title", field: "title" },
    { title: "Code", field: "template_code" },
    {
      title: "Status",
      field: "status",
      render: (rowData) => (
        <span
          className={
            rowData.status === "active"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800 capitalize"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800 capitalize"
          }
        >
          {" "}
          {rowData.status}
        </span>
      ),
    },
  ];
  const btnGroups = [
    {
      id: 1,
      title: "Add New",
      type: "addNew",
      path: "/push-template/add",
      key: "add",
    },
    {
      id: 2,
      title: "Make Active",
      type: "makeActive",
      path: "/push-template",
      key: "edit",
    },
    {
      id: 3,
      title: "Make Inactive",
      type: "makeInactive",
      path: "/push-template",
      key: "edit",
    },
    {
      id: 4,
      title: "Archive",
      type: "archive",
      path: "/push-template",
      key: "delete",
    },
    {
      id: 5,
      title: "Delete",
      type: "delete",
      path: "/push-template",
      key: "delete",
    },
  ].filter((btn) => accessRights?.[btn.key]);

  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [ids, setIds] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "PUSH_TEMPLATES");
      setAccessRights(rightsData);
      if (rightsData?.view === false) {
        history.push("/dashboard");
      }
    });
    getDatas();
  }, [location.state]);

  function getDatas() {
    setIsLoader(true);
    configuration
      .getAPI({ url: "push-template/list", params: {} })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setData(data.payload);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleAction(type) {
    if (ids.length < 1) {
      return toast.error("Please select at least one record");
    } else if (type === "delete") {
      setShowModal(true);
      return;
    }
    setIsLoader(true);
    const sendData = {
      ids,
      type:
        type === "makeActive"
          ? "active"
          : type === "makeInactive"
          ? "inactive"
          : type,
    };
    configuration
      .postAPI({ url: "push-template/action", params: sendData })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          getDatas();
          setIds([]);
          return toast.success(
            type === "delete"
              ? "Record deleted successfully"
              : "Record updated successfully"
          );
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleDelete() {
    setIsLoader(true);
    setShowModal(false);
    const sendData = {
      ids,
      type: "delete",
    };
    configuration
      .postAPI({ url: "push-template/action", params: sendData })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          getDatas();
          setIds([]);
          setShowModal(false);
          return toast.success("Record deleted successfully");
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleCancel() {
    setShowModal(false);
  }
  const onSelectionChange = (e) => {
    let idArr = pluck(e, "push_template_id");
    setIds(idArr);
  };

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.pushTemplate} />
      <DeleteModel
        mode={showModal}
        handleDelete={handleDelete}
        handleCancel={handleCancel}
      />
      <ListSection
        captionTitle="View Push Template"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        handleAction={handleAction}
        onSelectionChange={onSelectionChange}
      />
    </>
  );
}

export default View;
